var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPolygons1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 175,
    viewBox: "0 0 145 175",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.4087 146.836L122.574 123.535L127.171 162.176L91.4087 146.836Z",
    fill: "#4347A2",
    stroke: "#4347A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2601 46.7128L76.0425 51.5811L60.9352 68.0111L54.2601 46.7128Z",
    fill: "#4347A2",
    stroke: "#4347A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07265 127.206L13.9084 106.71L27.2409 124.61L5.07265 127.206Z",
    stroke: "#4347A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.064 29.673L100.553 13.6243L122.207 8.21507L116.064 29.673Z",
    stroke: "#4347A2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPolygons1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/polygons1.985cd00b.svg";
export { ForwardRef as ReactComponent };